import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { cache } from '@common/util/cache.operator';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { ConnectionType } from '@portal-core/publications/enums/publication-connection-type.enum';
import { Connector } from '@portal-core/publications/models/connector.model';
import { ConnectorService } from '@portal-core/publications/services/connector.service';
import { LoadingState } from '@portal-core/util/loading-state';
import { BehaviorSubject, catchError, Observable, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'mc-license-connectors-list',
  templateUrl: './license-connectors-list.component.html',
  styleUrls: ['./license-connectors-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LicenseConnectorsListComponent implements OnInit {
  @Input() licenseId: number;
  @Input() licenseUserId: number = null;
  @Output() connectorSelected = new EventEmitter<Connector | void>();

  ConnectionType: typeof ConnectionType = ConnectionType;
  loadingState: LoadingState<string> = new LoadingState<string>();
  licenseConnectors$: Observable<Connector[]>;
  reload$: BehaviorSubject<void> = new BehaviorSubject(undefined);

  constructor(private connectorService: ConnectorService, private errorService: ErrorService) { }

  reload() {
    this.loadingState.update(true);
    this.reload$.next();
  }

  ngOnInit() {
    this.loadingState.update(true);
    this.licenseConnectors$ = this.reload$.pipe(
      switchMap(() => {
        if (this.licenseUserId) {
          return this.connectorService.getUserConnectors$(this.licenseId).pipe(
            tap(() => {
              this.loadingState.update(false);
            }),
            catchError(error => {
              this.loadingState.update(false, 'There was a problem loading the license\'s connectors.', this.errorService.getErrorMessages(error));
              return of(null);
            })
          )
        } else {
          return this.connectorService.getLicenseConnectors$(this.licenseId).pipe(
            tap(() => {
              this.loadingState.update(false);
            }),
            catchError(error => {
              this.loadingState.update(false, 'There was a problem loading the license\'s connectors.', this.errorService.getErrorMessages(error));
              return of(null);
            })
          )
        }
      }),
      cache()
    );
  }

}
